<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Email Template Folder" />
    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button v-if="!edit" variant="primary" class="btn-pill mx-2" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
        <b-button v-if="edit" variant="success" class="btn-pill mx-2"
          @click="confirmAlert('Confirm to update number ?', 'update number')">
          <i class="fa fa-check"></i> Complete</b-button>
        <b-button v-if="edit" variant="danger" class="btn-pill" @click="edit = !edit">
          <i class="fa fa-check"></i> Cancel</b-button>
        <b-button v-if="!edit" variant="warning" class="text-dark btn-pill" @click="onloadFolder">
          <i class="icofont icofont-ui-edit"></i> Edit</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} Folder`">
          <div class="row">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.name.match('No')
                                ? 'required|numeric'
                                : form.validate
                                  ? form.rule
                                  : null"
                        v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <b-form-input :disabled="modalData.disable" :id="form.name" v-model="form.value"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <template #modal-footer>
            <b-button variant="primary" :disabled="invalid" @click="onSave(modalData)"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>
      <div class="card p-4">
        <div v-if="edit">
          <table class="table table border">
            <thead>
              <tr>
                <template v-for="(col, i) in columns.slice(0, 4)">
                  <th :key="i" scope="col" class="h6" v-if="col.field != 'no'">
                    {{ col.label }}
                  </th>
                </template>
              </tr>
            </thead>
            <draggable v-model="folderList" tag="tbody">
              <tr v-for="(item, j) in folderList" :key="j" class="row-table" style="cursor: all-scroll">
                <!-- <td scope="row">{{ item.no }}</td> -->
                <td scope="row">{{ item.name }}</td>
                <td scope="row">
                  {{ item.created_at | moment('YYYY-MM-DD, hh:mm ') }}
                </td>
                <td scope="row">
                  {{ item.updated_at | moment('YYYY-MM-DD, hh:mm ') }}
                </td>
              </tr>
            </draggable>
          </table>
        </div>
        <dataTableVue v-else ref="refDataTable" :isSearch="false" :isExport="true" :isFilter="true" v-bind:data="{
                  module: 'ccp',
                  columns: columns,
                  rows: rows,
                  exportDetail: exportDetail,
                  filter_col: [1, 2],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      edit: false,
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      show: false,
      form: [
        {
          value: '',
          col: 12,
          name: 'Name',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
      ],
      rows: [],
      columns: [
        {
          label: 'No',
          field: 'no',
          hidden: false,
        },
        {
          label: 'Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Created',
          field: 'created_at',
          hidden: false,
        },
        {
          label: 'Updated',
          field: 'updated_at',
          hidden: false,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      exportDetail: {
        fileName: 'export_template_folder',
        exportUrl: '',
      },
      folderList: [],
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  async created() {
    await this.loadItems();
  },
  methods: {
    async onloadFolder() {
      this.edit = !this.edit;
      await this.folderOption();
    },
    async folderOption() {
      let url = `/api/mail/folder/all`;
      const resFolder = await requestService.GetFetch('ccp', url);
      const folder = await resFolder.json();
      this.folderList = folder.data;
    },
    confirmAlert(title, type) {
      this.$swal
        .fire({
          title: title,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
          camcelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.isConfirmed) {
            switch (type) {
              case 'update number':
                this.onUpdateNumber();
                break;
            }
          }
        });
    },
    onUpdateNumber() {
      const url = `/api/mail/folder/convert/number`;
      var arr = [];
      this.folderList.forEach((element, index) => {
        let obj = {
          template_id: element._id,
          no: index + 1,
        };
        arr.push(obj);
      });
      const object = {
        data: arr,
      };
      requestService
        .PostFetch('ccp', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Folder has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          let sort = {
            sortField: 'no',
            params: {
              sortType: 'asc',
            },
          };
          this.loadItems(sort);
          this.edit = !this.edit;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
            filterParam: '',
          });
        });
    },
    deleteRow(value) {
      const url = `/api/mail/folder/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('ccp', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    onSave(value) {
      let data = this.form.map((item) => item.value);
      this.show = !this.show;
      const url = `/api/mail/folder${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      const object = {
        name: data[0],
      };

      requestService
        .PostFetch('ccp', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Folder has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });

          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
            filterParam: '',
          });
        });
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;
      this.show = !this.show;
      if (!value.match('Add')) {
        this.form[0].value = id.row.name;
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (key == 'sortType' && event.params[key] == '') {
            event.params[key] = 'asc';
          }
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        if (event.sortField != '') {
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
        } else {
          str += '&' + 'sortField=no';
        }

        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }
      if (str == '') {
        str = 'sortField=no&sortType=asc';
      }
      var url = '/api/mail/folder/filter?' + str;
      this.exportDetail.exportUrl = '/api/mail/folder/export?' + str;
      return requestService
        .GetFetch('ccp', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style>
.row-table:hover {
  background-color: #f1f5fd;
}
</style>
